module.exports = __webpack_public_path__ + "media/images/order/waiting_report-ebfb6c71a37a892c9e927b0c930c069a.jpg";